import { render, staticRenderFns } from "./TallerCRM.vue?vue&type=template&id=04b0dce8&scoped=true&"
import script from "./TallerCRM.vue?vue&type=script&lang=js&"
export * from "./TallerCRM.vue?vue&type=script&lang=js&"
import style0 from "./TallerCRM.vue?vue&type=style&index=0&id=04b0dce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b0dce8",
  null
  
)

export default component.exports